// extracted by mini-css-extract-plugin
module.exports = {"warning":"Notification_warning__2Lq9C","info":"Notification_info__2WSt7","error":"Notification_error__3nAMw","success":"Notification_success__1OzaP"};